import { type IDialogManagerButton } from '../../popup';
import { type IPageDialogActionComponentApi, PageDialogAction } from './page-dialog-action';

export const CANCEL_SUBMIT = 'CANCEL SUBMIT';

export abstract class PageUpdateAction<Request = any, API extends IPageDialogActionComponentApi<any> = any> extends PageDialogAction<Request, API> {
    protected processing: boolean = false;

    public run(request: Request = null): ReturnType<API['submit']> {
        this.processing = false;
        return super.run(request);
    }

    protected isValid() {
        return this.componentApi && this.componentApi.isValid();
    }

    protected submit() {
        return this.componentApi && this.componentApi.submit();
    }

    protected getTooltip() {
        return (
            this.componentApi && this.componentApi.getTooltip && this.componentApi.getTooltip instanceof Function && this.componentApi.getTooltip()
        );
    }

    protected get dialogActionTitle() {
        return 'common.actions.save';
    }

    protected get buttons(): IDialogManagerButton[] {
        return [this.cancelButton, this.submitButton];
    }
    protected get dialogActionCancelTitle() {
        return 'common.actions.cancel';
    }

    protected get cancelButton() {
        return {
            title: this.dialogActionCancelTitle,
            classes: 'cancel',
            action: function (popupScope) {
                popupScope.$dismiss();
            },
            disabled: () => this.processing
        };
    }

    protected get isCancelButtonDisabled() {
        return this.processing;
    }

    protected get submitButton(): IDialogManagerButton {
        return {
            title: this.dialogActionTitle,
            action: popupScope => {
                if (this.isValid() && !this.processing) {
                    this.processing = true;
                    this.submit()
                        .then(result => {
                            popupScope.$close(result);
                        })
                        .catch(error => {
                            if (error && error.message != CANCEL_SUBMIT) {
                                console.warn('Submit error:', error);
                                this.dialogManager.error(error);
                            }
                        })
                        .then(() => {
                            this.processing = false;
                            popupScope.$applyAsync();
                        });
                }
            },
            disabled: () => {
                return !this.isValid();
            },
            busy: () => this.isProcessing(),
            tooltip: () => this.getTooltip()
        };
    }

    protected isProcessing(): boolean {
        return this.processing;
    }
}
